<template>
  <content-div>

    <step-bar :step="step" :title="titles[step]"></step-bar>

    <!-- 약관 동의 요청 -->
    <subsc-solicitation-term-view v-if="step === 1"
                                  :solicitation="solicitation"
                                  @agreed="agreed"
                                  @error="(e)=>{alert('약관동의', e.message)}"
    />

    <!-- 약관 동의 완료 -->
    <subsc-solicitation-term-agreed-view v-if="step === 2"
                                         :solicitation="solicitation"
    />

    <!-- 결제 -->
    <subsc-solicitation-payment-view v-if="step === 3"
                                         :solicitation="solicitation"
    />

    <!-- 결제완료 -->
    <subsc-solicitation-completed-view v-if="step === 4"
                                     :solicitation="solicitation"
    />

    <div v-else class="contArea tpd10" style="text-align: center; font-size: 1.5rem">
      <span>{{errMsg}}</span>
    </div>

    <popup-alert v-if="activatedAlert" :title="alertTitle" :btn_cancel="alertCancelButton" @close="closeAlert()">
      <popup-msg :type="alertMsg"></popup-msg>
    </popup-alert>

  </content-div>
</template>


<script>
import axios from "axios";
import {api} from "../../../api";

import StepBar from "./StepBar.vue";
import PopupAlert from '../../../components/Popup/PopupAlert.vue';
import PopupMsg from "../../../components/Popup/PopupMsgTemplate";

import SubscSolicitationTermView from "./SubscSolicitationTermView";
import SubscSolicitationTermAgreedView from "./SubscSolicitationTermAgreedView";
import SubscSolicitationPaymentView from "./SubscSolicitationPaymentView";
import SubscSolicitationCompletedView from "./SubscSolicitationCompletedView";

export default {
  components: {
    StepBar,
    SubscSolicitationTermView,
    SubscSolicitationTermAgreedView,
    SubscSolicitationPaymentView,
    SubscSolicitationCompletedView,

    PopupAlert,
    PopupMsg,
  },


  created() {
    window.scroll(0, 0);
    this.getSolicitation();
  },


  data() {
    return {
      titles: ['',
        'BMW ServiceCare+ 약관',
        'BMW ServiceCare+ 약관 동의 완료',
        'BMW ServiceCare+ 결제 요청',
        'BMW ServiceCare+ 결제 완료',
      ],
      step: 0,
      info: true,
      selected: [],
      solicitation: null,
      hasSolicitation: false,
      errMsg: null,

      activatedAlert: false,
      alertTitle: null,
      alertMsg: null,
      alertCancelButton: false,
    };
  },


  watch: {
    solicitation(v) {
      if (v===null) {
        this.step = -1;
      } else{
        let steps = {10:1, 20: 2, 50:3, 60:4};
        this.step = steps[this.solicitation.state];
      }
    },
  },


  computed: {
  },


  methods: {
    closeAlert() {
      this.activatedAlert = false;
    },

    alert(title, message){
      this.activatedAlert = true;
      this.alertTitle = title;
      this.alertMsg = message;
      this.alertCancelButton=false;
    },

    getSolicitation(){
      axios.get(api.subscSolicitations+'/'+this.$route.params.hash)
          .then((res)=>{
            this.solicitation = res.data.data
          })
          .catch((e)=>{
            this.step = -1;
            this.errMsg = e.response.data.msg || '구독 신청 조회 중 오류가 발생하였습니다.';
          })
    },

    agreed(solicitation){
      this.solicitation = solicitation;
    },
  },
};
</script>

